import { PointrThemedNavbarState, pointrThemedNavbarState } from './State'

import { SET_MENU_ANCHOR, SET_USER_ACTIONS_MENU_ANCHOR, RESET, PointrThemedNavbarAction } from './Actions'

function pointrThemedNavbarReducer(
  state: PointrThemedNavbarState,
  action: PointrThemedNavbarAction
): PointrThemedNavbarState {
  switch (action.type) {
    case SET_MENU_ANCHOR:
      return Object.assign({}, state, { menuAnchor: action.payload })
    case SET_USER_ACTIONS_MENU_ANCHOR:
      return Object.assign({}, state, { userActionsMenuAnchor: action.payload })
    case RESET:
      return pointrThemedNavbarState
    default:
      return state
  }
}

export default pointrThemedNavbarReducer
